import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination-item" }
const _hoisted_2 = {
  key: 0,
  class: "pagination-item__dots"
}
const _hoisted_3 = ["aria-label"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-pagination-item',
  props: {
  page: {
    type: Number,
    default: null,
  },
  current: {
    type: Number,
    default: 0,
  },
},
  emits: ["update"],
  setup(__props, { emit }) {

const props = __props;





const isActive = computed(() => {
  return props.page === props.current;
});

function clickHandler() {
  emit("update", props.page);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (__props.page === null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " ... "))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass(["pagination-item__page", { 'pagination-item__page--active': isActive.value }]),
          type: "button",
          "aria-label": `Перейти к странице ${__props.page}`,
          onClick: clickHandler
        }, _toDisplayString(__props.page), 11, _hoisted_3))
  ]))
}
}

})